export const capitalize = (value: string): string => {
	return value.charAt(0).toUpperCase() + value.slice(1);
}

export const convertToPercentage = (value: number): string => {
	const percentage = value || 0;
	const isFloat = Number(percentage) === percentage && percentage % 1 !== 0;
	return isFloat ? percentage.toFixed(1) + '%' : percentage.toFixed(0) + '%';
}